import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const { WidgetPlaygroundView } = loadable(() => import('../components/WidgetPlayground/WidgetPlaygroundView'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('WidgetPlayground own props', ownProps);
    return {
        user: state.AppReducer.user,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        userGroupRoles: state.AppReducer.userGroupRoles,
        contextCustomer: state.AppReducer.contextCustomer,
        contextObject: state.AppReducer.contextCustomer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('WidgetPlayground Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WidgetPlaygroundView);
